$(function () {

    $(document).ready(function () {
        // handle the scrolling and setting the background color
        $(window).scroll(function () {
            if ($(window).scrollTop() > 38) {
                $('.navbar').addClass('fixed-top').addClass('shadow-sm');
                $('.navbar').css('top', 0);
                $('.navbar').removeClass('sticky-top');
            } else {
                $('.navbar').addClass('sticky-top');
                $('.navbar').removeClass('fixed-top').removeClass('shadow-sm');
                $('.navbar').prop('style').removeProperty('top');
            }
        })

        $('#public-nav-toggle').click(function () {
            $('#public-nav-toggle-menu').slideToggle();
        });
        $('#public-nav-mobile-toggle').click(function () {
            $('#public-nav-toggle-mobile-menu').slideToggle();
        });
    });
});